import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Timeline from './Timeline';
import Dashboard from './Dashboard';
import SearchInput from './SearchInput';
import MyLocation from './MyLocation';

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  pointer-events: none;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: 0.075em;
  `;

const Wrapper = styled.div`
  position: relative;
  color: white;
  max-width: 1250px;
  margin: 0 auto;
  pointer-events: none;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1px);
`;

const BgContainer = styled.div`
  background-color: rgba(0,0,0,0.57);
  margin-bottom: 3px;

  @media only screen and (max-height: 479px),
  only screen and (max-width: 399px) {
    margin-bottom: 0;
  }
`;

const Info = styled.div`
font-family: "Source Code Pro", sans-serif;
letter-spacing: 0.025em;
text-shadow: -1px -1px 2px #000,
1px -1px 2px #000,
-1px 1px 2px #000,
1px 1px 2px #000,
-1px -1px 2px #000,
1px -1px 2px #000,
-1px 1px 2px #000,
1px 1px 2px #000;
font-size: 0.875rem;
line-height: 1rem;
display: flex;
padding: 5px 3vw;
align-items: center;

@media only screen and (max-width: 639px) {
  font-size: 0.75em;
  flex-direction: column-reverse;
  padding: 3px 6px;
}

@media only screen and (max-height: 479px), only screen and (max-width: 399px) {
  line-height: 1em;
  padding: 2px 10px 5px;
}
`;

const Location = styled.div`
position: relative;
padding-right: 36px;
max-height: 28px;

@media only screen and (max-width: 639px) {
  order: 1;
  width: 100%;
}
`;

const LocationContainer = () => (
  <Location>
    <SearchInput />
    <MyLocation />
  </Location>
);

const TopSection = ({ isMapUi }) => (
  <Container>
    <BgContainer>
      <Wrapper>
        <Timeline />
      </Wrapper>
    </BgContainer>
    <BgContainer>
      <Wrapper>
        <Info>
          <Dashboard />
          { isMapUi ? <LocationContainer /> : null }
        </Info>
      </Wrapper>
    </BgContainer>
  </Container>
);

TopSection.propTypes = {
  isMapUi: PropTypes.bool.isRequired,
};

export default connect(
    ({ ui }) => ({
      isMapUi: ui.isMapUi,
    }),
)(TopSection);
